import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export default function DataSetFieldRow({
  field,
  index,
  updateField
}) {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: field.key });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <tr ref={setNodeRef} style={style}>

      {/* drag handle */}
      <td
        style={{ width: 32, cursor: "grab", textAlign: "center" }}
        {...attributes}
        {...listeners}
      >
        ⋮⋮
      </td>

      {/* row number */}
      <td style={{ width: 40, textAlign: "center", color: "#777" }}>
        {index + 1}
      </td>

      {/* label */}
      <td>
        {field.label || field.key}
      </td>

      {/* type */}
      <td style={{ textAlign: "center", color: "#666" }}>
        {field.type || "text"}
      </td>

      {/* enabled / required */}
      <td style={{ textAlign: "center" }}>
        <input
          type="checkbox"
          checked={!!field.required}
          onChange={(e) =>
            updateField(index, "required", e.target.checked)
          }
        />
      </td>

      {/* visible */}
      <td style={{ textAlign: "center" }}>
        <input
          type="checkbox"
          checked={!!field.visible}
          disabled={!field.required}
          onChange={(e) => {
            const checked = e.target.checked;

            updateField(index, "required", checked);

            if (!checked) {
              updateField(index, "visible", false);
            }
          }}
        />
      </td>

    </tr>
  );
}
